import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb,
} from "assets/jss/material-dashboard-react.js";
import brandTheme from "brandTheme/Theme";

const dashboardStyle = {
  successText: {
    color: successColor[0],
  },
  upArrowCardCategory: {
    width: "16px",
    height: "16px",
  },
  stats: {
    color: grayColor[0],
    display: "inline-flex",
    fontSize: "12px",
    lineHeight: "22px",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      top: "4px",
      fontSize: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px",
    },
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0",
    textAlign:"center",
  },
  cardCategoryWhite: {
    color: "rgba(" + hexToRgb(whiteColor) + ",.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  nextButton1:{
    color:brandTheme.white,
    backgroundColor:"#432342",
    "&:hover":{
    backgroundColor:brandTheme.buttonHoverColor,
    }
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    textAlign:"center",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  cardTitleWhite: {
    color: whiteColor,
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  selectText: {
    padding: "12px 8px",
    fontSize: "0.8125rem",
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 300,
    lineHeight: 1.42857143,
    verticalAlign: "middle",
  },
  buttonstyle: {
    border: "2px solid #2390d2",
    backgroundColor: "transparent",
    color: "#000000",
    "&:hover": {
      backgroundColor: "#2390d2",
      color: "#FFFFFF",
    },
  },
};

export default dashboardStyle;
